import script from "./BrowserSupportPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrowserSupportPopup.vue?vue&type=script&setup=true&lang=ts"

import "./BrowserSupportPopup.vue?vue&type=style&index=0&id=098da90e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-098da90e"]])

export default __exports__